"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GOVERNMENT = exports.COURT = exports.BUSINESS = exports.INDIVIDUAL = exports.INSIDER = exports.EMPLOYER = exports.CREDITOR = exports.DEBTOR = exports.LANDLORD = exports.CODEBTOR = exports.DEPENDENT = void 0;
var DEPENDENT = 'dependent';
exports.DEPENDENT = DEPENDENT;
var CODEBTOR = 'codebtor';
exports.CODEBTOR = CODEBTOR;
var LANDLORD = 'landlord'; // DEPRECATE ALL BELOW

exports.LANDLORD = LANDLORD;
var DEBTOR = 'debtor';
exports.DEBTOR = DEBTOR;
var CREDITOR = 'creditor';
exports.CREDITOR = CREDITOR;
var EMPLOYER = 'employer'; // NOTE: Get rid of this?

exports.EMPLOYER = EMPLOYER;
var INSIDER = 'insider';
exports.INSIDER = INSIDER;
var INDIVIDUAL = 'individual';
exports.INDIVIDUAL = INDIVIDUAL;
var BUSINESS = 'business';
exports.BUSINESS = BUSINESS;
var COURT = 'court';
exports.COURT = COURT;
var GOVERNMENT = 'government';
exports.GOVERNMENT = GOVERNMENT;